<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('close')">
    <CBox>
      <OmtRow mt="16px">
        <OmtIcons name="paper-plane-top" size="3x" mb="32px" color="#172972" />
      </OmtRow>
      <OmtRow mb="32px">
        <OmtTypography as="h1-large">
          Resposta enviada <br />
          com sucesso!
        </OmtTypography>
      </OmtRow>

      <OmtRow>
        <OmtTypography as="p3" fontWeight="700">
          <CFlex>
            <OmtIcons name="memo" mr="14px" size="1x" />
            Protocolo: {{ protocol }}
          </CFlex>
        </OmtTypography>
      </OmtRow>

      <OmtRow mt="32px">
        <div class="warning">
          <CFlex px="16px" pt="16px" pb="14px" align-items="center">
            <OmtIcons name="bell-on" mr="14px" size="1x" />
            <OmtTypography as="p3" fontWeight="700">
              A análise será feita em até {{ daysAnalizy }} dias úteis
            </OmtTypography>
          </CFlex>
          <CFlex ps="27px" mb="16px" px="16px" pb="16px">
            <OmtTypography as="p1">
              Você pode acompanhar o status dessa solicitação pela área Minhas Solicitações.
            </OmtTypography>
          </CFlex>
        </div>
      </OmtRow>
    </CBox>
    <template #footer>
      <OmtButton w="100%" @click="$emit('close')"> Fechar </OmtButton>
    </template>
  </OmtStickedModal>
</template>
<script>
export default {
  name: "SendPendency",
  props: {
    isOpen: {
      Type: Boolean
    },
    protocol: {
      type: String
    },
    daysAnalizy: {
      type: Number
    }
  }
};
</script>

<style scoped>
.font--bold {
  font-weight: var(--fontWeights-bold);
}

.warning {
  background-color: #f6f6f9;
  border-radius: 8px;
  margin-bottom: 170px;
}
</style>
